import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, mergeProps as _mergeProps, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("提交")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.visible,
    title: "修改密码",
    onCancel: _ctx.handleClose
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_a_button, {
        key: "submit",
        type: "primary",
        loading: _ctx.loading,
        onClick: _ctx.handleSubmit
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["loading", "onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_form, _mergeProps({
        ref: "formRef",
        model: _ctx.formState,
        rules: _ctx.rules
      }, _ctx.layout), {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            "has-feedback": "",
            label: "旧密码",
            name: "oldPassword"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input_password, {
                value: _ctx.formState.oldPassword,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.oldPassword) = $event)),
                autocomplete: "off"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            "has-feedback": "",
            label: "新密码",
            name: "password"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input_password, {
                value: _ctx.formState.password,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.password) = $event)),
                autocomplete: "off"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            "has-feedback": "",
            label: "确认新密码",
            name: "confirmPasswprd"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input_password, {
                value: _ctx.formState.confirmPasswprd,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.confirmPasswprd) = $event)),
                autocomplete: "off"
              }, null, 8, ["value"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 16, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["visible", "onCancel"]))
}